export const START_AUTO_ADVANCE = "START_AUTO_ADVANCE";
export const STOP_AUTO_ADVANCE = "STOP_AUTO_ADVANCE";
